module.exports = __webpack_public_path__ + "static/media/download-arrow.cff1ea87.svg";